import { Component, Input, ViewEncapsulation } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { SalesforceField, SalesforceFieldTypes } from '../model/salesforce-form.model';

@Component({
  selector: 'app-salesforce-field',
  templateUrl: './salesforce-field.component.html',
  styleUrls: ['./salesforce-field.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SalesforceFieldComponent {
  @Input() field: SalesforceField;
  @Input() form: UntypedFormGroup;
  @Input() context: string;
  @Input() errorText: string;
  @Input() chatId: string;

  dateMask = [/[1-9]/, /\d/, /\d/, /\d/, '-', /[0-1]/, /\d/, '-', /[0-3]/, /\d/];
  datetimeMask = [/[1-9]/, /\d/, /\d/, /\d/, '-', /[0-1]/, /\d/, '-', /[0-3]/, /\d/, ' ', /[0-2]/, /\d/, ':', /[0-5]/, /\d/];
  timeMask = [/[0-2]/, /\d/, ':', /[0-5]/, /\d/];

  salesforceFieldTypes = SalesforceFieldTypes;

  get isValid() {
    return this.form.controls[this.field.name].valid;
  }

  get isEnabled() {
    return this.form.controls[this.field.name].enabled;
  }

  getPlaceholder(): string {
    switch (this.field.type) {
      case SalesforceFieldTypes.DATE:
        return 'yyyy-mm-dd';
      case SalesforceFieldTypes.DATETIME:
        return 'yyyy-mm-dd hh:mm';
      case SalesforceFieldTypes.TIME:
        return 'hh:mm';
      default:
        return '';
    }
  }

  getMask(): any[] {
    switch (this.field.type) {
      case SalesforceFieldTypes.DATE:
        return this.dateMask;
      case SalesforceFieldTypes.DATETIME:
        return this.datetimeMask;
      case SalesforceFieldTypes.TIME:
        return this.timeMask;
      default:
        return [];
    }
  }
}
